import React from 'react'
import './radio.css'


function Radio({options, selected, onChange}) {
    return (
        <div className="radio">
          {options.map((option, index)=>(
            <div className={"option "+ (selected===index? "selected":"")} onClick={()=>onChange(index)}>
              {option.text}
            </div>
          ))}
        </div>
    )
}

export default Radio